var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"products-page page__content"},[_c('h1',{staticClass:"products-page__title"},[_vm._v("Наши продукты")]),_c('div',{staticClass:"products-page__cards"},_vm._l((_vm.products),function(product,idx){return _c('vr-large-product-card',{key:`grid-item-${idx}`,attrs:{"product":product,"dark":product.dark}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }